import type { ProfileResponse } from '@/services/profile.service';
import { extensionSyncService } from '@/services/extension-sync.service';

const ZUSTAND_PROFILE_KEY = 'profile-storage';

export const localProfileService = {
  async getProfile(): Promise<ProfileResponse> {
    console.log('🔍 [LocalProfile] Loading profile from Zustand storage...');

    try {
      // Get profile from Zustand persist storage
      const storedState = localStorage.getItem(ZUSTAND_PROFILE_KEY);
      console.log('📦 [LocalProfile] Zustand storage exists:', !!storedState);

      if (storedState) {
        const parsedState = JSON.parse(storedState);
        const profile = parsedState.state?.profile;
        console.log('📦 [LocalProfile] Profile in Zustand state:', !!profile);

        if (profile && profile.firstName && profile.lastName) {
          console.log('👤 [LocalProfile] Profile name:', profile.firstName, profile.lastName);
          console.log('📧 [LocalProfile] Profile email:', profile.email || 'NO EMAIL');
          return profile;
        }
      }
    } catch (error) {
      console.error('❌ [LocalProfile] Error loading from Zustand storage:', error);
    }

    // Return default empty profile if not found
    console.log('⚠️ [LocalProfile] No profile found, returning default');
    return {
      id: 'local-profile',
      userId: 'local-user',
      firstName: '',
      lastName: '',
      email: '',
      phone: null,
      location: null,
      summary: null,
      experience: [],
      education: [],
      skills: [],
      certifications: [],
      languages: [],
      createdAt: new Date(),
      updatedAt: new Date(),
    };
  },

  async saveProfile(profile: ProfileResponse): Promise<ProfileResponse> {
    console.log('💾 [LocalProfile] Profile save called - but profile is managed by Zustand');
    // Note: Profile is actually saved by Zustand persist middleware
    // This method is kept for compatibility but doesn't need to do anything
    return profile;
  },

  async deleteProfile(): Promise<void> {
    console.log('🗑️ [LocalProfile] Deleting profile from Zustand storage...');
    try {
      localStorage.removeItem(ZUSTAND_PROFILE_KEY);
      console.log('✅ [LocalProfile] Profile deleted from Zustand storage');

      // Sync profile deletion with extension
      console.log('🔄 [LocalProfile] Syncing profile deletion to extension...');
      await extensionSyncService.syncProfileDeletionToExtension();

    } catch (error) {
      console.error('❌ [LocalProfile] Error deleting profile:', error);
    }
  },

  async hasProfile(): Promise<boolean> {
    try {
      const storedState = localStorage.getItem(ZUSTAND_PROFILE_KEY);
      if (!storedState) return false;

      const parsedState = JSON.parse(storedState);
      const profile = parsedState.state?.profile;

      const hasProfile = !!(profile && profile.firstName && profile.lastName);
      console.log('🔍 [LocalProfile] Profile exists check:', hasProfile);

      return hasProfile;
    } catch (error) {
      console.error('❌ [LocalProfile] Error checking profile existence:', error);
      return false;
    }
  },
};












